export default __webpack_public_path__ + "static/media/VerifyOTP.cac11f0c.svg";